import TheftRecovery from "./TheftRecovery.js";
export default {
  install(molten) {
    molten.addPlugin('Action', TheftRecovery);
  }
};